import { Sparkles, Clock, ShieldCheck, Leaf } from "lucide-react";

const POINTS = [
  { icon: Sparkles, title: "Boutique attention", body: "One vehicle at a time. Total focus from arrival to handover." },
  { icon: Clock, title: "We come to you", body: "Fully mobile across Christchurch — driveway, office park, or kerbside." },
  { icon: ShieldCheck, title: "Safe on every surface", body: "pH-balanced products, plush mitts, decontaminated water." },
  { icon: Leaf, title: "Mindful of waste", body: "Water-smart wash methods built for NZ conditions." },
];

const ABOUT_IMG = "/about.jpg";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="text-xs uppercase tracking-[0.25em] text-gold">03 — About</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
            Christchurch's quietly obsessed detailers.
          </h2>
          <p className="mt-6 text-neutral-300 text-base sm:text-lg leading-relaxed">
            AB Car Detail is a small, owner-run studio. We believe a properly
            detailed car is calmer to drive, easier to sell, and more enjoyable to
            own. So we treat every vehicle like it's our own daily.
          </p>
          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {POINTS.map((p) => (
              <div key={p.title} className="bg-[#0a0a0a] border border-white/10 p-5 rounded-xl">
                <p.icon className="w-5 h-5 text-white/80" strokeWidth={1.5} />
                <div className="font-display font-bold mt-3">{p.title}</div>
                <div className="text-sm text-neutral-400 mt-1.5 leading-relaxed">{p.body}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
            <img src={ABOUT_IMG} alt="Foam wash on a customer's Nissan 180SX" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-neutral-300">Owner-operated</div>
                <div className="font-display font-bold text-2xl mt-1">Mobile across Christchurch</div>
              </div>
              <div className="bg-gold text-black px-3 py-2 text-[11px] font-bold uppercase tracking-[0.18em]">
                Est. AB
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
